export function HowItWorks() {
  return (
    <section id="how-it-works" aria-labelledby="how-it-works-heading">
      <h2 id="how-it-works-heading" className="section-heading">
        Cómo funciona
      </h2>
      <div className="wireframe-columns">
        <div>
          <h3>Arquitectura</h3>
          <p>
            Aplicación 100% estática: React + TypeScript en el navegador, motor de dominio como funciones puras
            (<code>src/domain</code>), ejecución en un Web Worker cancelable (<code>src/worker</code>) y
            persistencia local opcional en IndexedDB (<code>src/storage</code>). No hay backend propio, ni
            cuentas, ni datos que salgan del dispositivo.
          </p>
          <p>
            El adaptador remoto opcional que contempla el PRD (P2) está deshabilitado por diseño (kill switch
            permanente en este MVP): activar <code>options.deterministic: false</code> solo añade un aviso
            informativo y el motor sigue corriendo en local.
          </p>
        </div>
        <div>
          <h3>Límites honestos</h3>
          <ul className="demo-list">
            <li>Hasta 500 filas y 60 campos por ejecución; archivos de hasta 10 MB.</li>
            <li>La detección de campos candidatos es heurística (nombre + patrón de valores): puede tener falsos positivos y negativos.</li>
            <li>
              <strong>
                Esta herramienta no certifica anonimización real ni protege por sí sola frente a reidentificación
                por combinación de campos.
              </strong>{" "}
              Valida el resultado con criterio experto antes de compartir cualquier dataset derivado.
            </li>
            <li>La exportación solo incluye el dataset ya enmascarado; nunca los valores originales de un campo cubierto.</li>
          </ul>
        </div>
      </div>
    </section>
  );
}
